import React from "react";
import CourseItem from "../CourseItem";
import style from "./index.module.scss";
import useRequest from "../../../../../Utils/useRequest";
import { getNoWeekTimeCourseList, getNetCourseList } from "../../../../../API";
import useStorage from "../../../../../Utils/useStorage";
import Config from "../../../../../config";
import { Spin } from "antd";
import courseImg from "./images/course.png";
import courseImg2 from "./images/course2.png";
import courseImg3 from "./images/course3.png";
import courseImg4 from "./images/course4.png";
import courseImg5 from "./images/course5.png";
import courseImg6 from "./images/course6.png";
import CustomEmpty from "../../../../../components/CustomEmpty";
import AddModal from "pages/CourseList/PC/components/AddModal";

function getImgUrl(index: number) {
    const ImgArr = [
        courseImg,
        courseImg2,
        courseImg3,
        courseImg4,
        courseImg5,
        courseImg6
    ];
    const num = index % ImgArr.length;
    return ImgArr[num];
}

interface ListProps {
    open: boolean;
    onCancel: () => void;
}

function List({ open, onCancel }: ListProps) {
    const [batch] = useStorage(
        "batch",
        localStorage.getItem("batch") || Config.DefaultBatch
    );
    const [data, { loading }, refreshNet] = useRequest(
        () => getNetCourseList(batch),
        {},
        [batch]
    );
    const [dataNoWeekTime, { loading: dataNoWeekTimeLoading }, refreshNoWeek] =
        useRequest(() => getNoWeekTimeCourseList(batch), {}, [batch]);

    function refreshData() {
        refreshNet();
        refreshNoWeek();
    }

    return (
        <div>
            <Spin spinning={loading || dataNoWeekTimeLoading}>
                <div className={style.root}>
                    {dataNoWeekTime &&
                        dataNoWeekTime.map((item, index) => (
                            <CourseItem
                                key={index}
                                className={style.item}
                                data={item}
                                imgUrl={getImgUrl(index)}
                            />
                        ))}
                    {data &&
                        data.map((item, index) => (
                            <CourseItem
                                key={index}
                                className={style.item}
                                data={item}
                                imgUrl={getImgUrl(
                                    (dataNoWeekTime
                                        ? dataNoWeekTime.length
                                        : 0) + index
                                )}
                                planCourse={false}
                            />
                        ))}
                    {(!data || data.length === 0) &&
                        (!dataNoWeekTime || dataNoWeekTime.length === 0) && (
                            <CustomEmpty className={style.customEmpty} />
                        )}
                </div>
            </Spin>
            {open && (
                <AddModal
                    onCancel={onCancel}
                    onOk={refreshData}
                    batch={batch}
                />
            )}
        </div>
    );
}

export default List;
